<template>
    <j-page>
        <div slot="search">
            <j-page-search title="台账标题">
                <el-input v-model.trim="query.ledgerName" placeholder="请输入台账标题" clearable @keydown.native.enter="searchEvent" />
            </j-page-search>
            <el-button type="primary" icon="el-icon-search" @click="searchEvent">查询</el-button>
            <el-button type="info" icon="el-icon-refresh" @click="resetEvent">重置</el-button>
            <el-button type="warning" icon="el-icon-plus" @click="addDgmxEvent">新增</el-button>
        </div>
        <div slot="table">
            <el-table v-loading="tableLoading" :data="tableData" height="100%" stripe>
                <el-table-column type="index" label="序号" align="center" width="50" />
                <el-table-column prop="ledgerName" label="台账名称" align="center" show-overflow-tooltip />
                <el-table-column prop="createTime" label="创建时间" align="center" show-overflow-tooltip />
                <el-table-column label="操作" width="160">
                    <template slot-scope="scope">
                        <el-button @click.stop="collectionEvent(scope.row)" type="text" class="common-button-add">信息采集</el-button>
                        <el-button @click.stop="editDgmxEvent(scope.row)" type="text" class="common-button-edit">编辑</el-button>
                        <el-button @click.stop="delEvent(scope.row)" type="text" class="common-button-del" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div slot="pagination" v-show="query.total > query.limit">
            <el-pagination
                    :current-page="query.page"
                    :page-size="query.limit"
                    :total="query.total"
                    :background="pmxBackground"
                    :pager-count="pmxCount"
                    :layout="pmxLayout"
                    :pageSizes="pmxSizes"
                    @current-change="changePage"
                    @size-change="sizeChange"
            />
        </div>
        <!--新增-->
        <el-dialog v-if="showDgmx" :title="dgmxTypeMap[dgmxType]" :visible.sync="showDgmx" width="400px" top="15%" :close-on-click-modal="false">
            <el-form ref="dgmxDom" :model="dgmxForm" :rules="dgmxRule" :label-width="dgmxFormLabelWidth" @keydown.native.enter="checkDgmxEvent('saveDgmxData')">
                <el-form-item label="台账名称" prop="ledgerName">
                    <el-input v-model.trim="dgmxForm.ledgerName" placeholder="请输入台账名称" maxlength="30" show-word-limit clearable />
                </el-form-item>
                <el-form-item label="关联菜单" prop="generateMenu">
                    <j-dictionary v-model="dgmxForm.generateMenu" code="YES_NO" placeholder="请选择是否关联菜单" type="checkbox"/>
                </el-form-item>
                <el-form-item v-if="dgmxForm.generateMenu == 1" label="挂载菜单" prop="menuId">
                    <el-select v-model="dgmxForm.menuId" clearable filterable placeholder="请选择要挂载的菜单" style="width: 100%">
                        <el-option v-for="menu in menuList" :key="menu.menuId" :label="menu.name" :value="menu.menuId"/>
                    </el-select>
                </el-form-item>
            </el-form>
            <template slot="footer">
                <el-button type="primary" @click="checkDgmxEvent('saveDgmxData')" :loading="submitLoad">保存</el-button>
                <el-button @click="showDgmx = false">取消</el-button>
            </template>
        </el-dialog>
        <!--信息采集-->
        <data-config v-if="showConfig" :close.sync="showConfig" :meta="curItem" />
    </j-page>
</template>

<script>
    import PageMixins from "../../components/JComponents/JPage/mixins/PageMixins";
    import PaginationMixins from "../../components/JComponents/JPage/mixins/PaginationMixins";
    import DialogMixins from "../../components/JComponents/JPage/mixins/DialogMixins";
    import DataConfig from "./dynamic/DataConfig";
    export default {
        name: "DynamicManage",
        mixins: [PageMixins, PaginationMixins, DialogMixins],
        components: {
            DataConfig
        },
        data() {
            return {
                showConfig: false,
                menuList: [],
                menuMap: {},
                query: {
                    ledgerName: ''
                },
                dgmxForm: {
                    ledgerName: '',
                    generateMenu: '',
                    menuId: '',
                    ledgerMenu: null
                },
                dgmxRule: {
                    ledgerName: [{ required: true, message: '请输入台账名称', trigger: 'blur' }],
                    generateMenu: [{ required: true, message: '请选择是否关联菜单', trigger: 'change' }],
                    menuId: [{ required: true, message: '请选择挂载菜单', trigger: 'change' }]
                }
            }
        },
        created() {
            this.load()
        },
        methods: {
            addDgmxEvent() {
                this.getMenuList()
                this.dgmxType = 'ADD'
                this.showDgmx = true
            },
            async editDgmxEvent(row) {
                this.dgmxType = 'EDIT'
                this.getMenuList()
                // 详情接口填充详情数据
                this.curItem = await this.getDetailMetaData(`/api/dynamicLedgerManages/${row.ledgerId}`) // 函数定义在PageMixins中
                this.dgmxForm = this.proxyDgmxData({...this.dgmxForm, ...this.curItem})
                if (this.dgmxForm.ledgerMenu) this.dgmxForm.menuId = this.dgmxForm.ledgerMenu.menu.parentId
                this.showDgmx = true
            },
            async getMenuList() {
                this.menuMap = {}
                const {data} = await this.$http.get(`/api/admins/menus`)
                this.menuList = data.data
                this.menuList.forEach(menu => {
                    this.menuMap[menu.menuId] = menu.name
                })
            },
            collectionEvent(row) {
                this.curItem = row
                this.showConfig = true
            },
            delEvent (row) {
                this.$confirm('您确认要删除当前记录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.request({ method: 'delete', url: `/api/dynamicLedgerManages/${row.ledgerId}`})
                        .then((res) => {
                            if (res.data.status !== 'yes') return this.$message.error(res.data.msg)
                            this.pageUpdate(this.query)
                            this.$message.success('删除成功')
                            this.load && this.load()
                        })
                })
            },
            async load () {
                this.tableLoading = true
                const { data } = await this.$http.get(`/api/dynamicLedgerManages/page`, {
                    params: this.query
                }).finally(() => {
                    this.tableLoading = false
                })
                if (data.status !== 'yes') return this.$message.warning(data.msg || data.message || `接口异常`)
                this.tableData = data.data.data
                this.query.total = data.data.total
                this.tableLoading = false
            },
            async saveDgmxData () {
                if (this.submitLoad) return
                this.submitLoad = true
                let method = 'post'
                let url = `/api/dynamicLedgerManages`
                if (this.dgmxType === 'EDIT') {
                    url = `/api/dynamicLedgerManages/${this.curItem.ledgerId}`
                    method = 'put'
                }
                const menu = {
                    'address': (this.dgmxForm.ledgerMenu && this.dgmxForm.ledgerMenu.menu.address) || `trends-menu-${Date.now()}`,
                    'icon': '',
                    'name': this.dgmxForm.ledgerName,
                    'orderNo': 99,
                    'parentId': this.dgmxForm.menuId
                }
                this.dgmxForm.ledgerMenu = { content: '', menu }
                const { data } = await this.$http[method](url, this.dgmxForm)
                    .catch(({response}) => { this.$message.error(response.data.msg) })
                    .finally(() => { this.submitLoad = false })
                if (data.status !== 'yes') return this.$message.error(data.msg)
                this.showDgmx = false
                this.$message.success('提交成功')
                this.load()
            }
        }
    }
</script>

<style lang="scss">
    .dynamic-manage {

    }
</style>
